export const auxSelectFromEnum = (enumeration) => [
    {
        values: Object.keys(enumeration).map((r) => ({
            displayValue: enumeration[r],
            isSelected: false,
            value: enumeration[r]
        }))
    }
];
export const auxSelectFromEnumWithSuffix = (enumeration, suffix) => [
    {
        values: Object.keys(enumeration).map((r) => ({
            displayValue: enumeration[r] + suffix,
            isSelected: false,
            value: enumeration[r]
        }))
    }
];
export const getEnumValues = (enumeration) => Object.keys(enumeration)
    .filter((type) => !isNaN(Number(type)))
    .map((type) => Number(type));
export const parseEnum = (enumObj, value) => enumObj[value];
